const template = require('./edit-cell-font.hbs');

module.exports = Backbone.View.extend({
  events: {
    'change select[name="font-size"]': 'setFontSize',
    'change select[name="font-family"]': 'setFontFamily'
  },

  setFontSize: function (event) {
    INKIVE.Table.setFontSize(parseInt(event.target.value));
  },

  setFontFamily: function (event) {
    INKIVE.Table.setFontFamily(event.target.value);
  },

  initialize: function (options) {
    this.element = options.selectedElement;
    this.fonts = []; // Will be changed on next commit
    this.render();
  },

  render: function () {
    this.$el.html(template({ fonts: this.fonts }));
  }
});
